import { createFileRoute } from "@tanstack/react-router";

import AddAccount3 from "@/features/onboarding/AddAccount3";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-account-3")({
  component: () => (
    <BasicLayout>
      <AddAccount3 />
    </BasicLayout>
  ),
});
